import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";

export type OnboardingTaskRow = {
  id: string;
  partner_id: string;
  title: string;
  description: string | null;
  due_date: string | null;
  status: string;
  assigned_to_partner: boolean;
  completed_at: string | null;
  created_at: string;
};

// GET /api/portal/onboarding — partner's own onboarding checklist.
// Server filters to assigned_to_partner=true; internal-only tasks stay
// invisible to the partner.
export function usePartnerOnboarding() {
  return useQuery<OnboardingTaskRow[], ApiClientError>({
    queryKey: queryKeys.portal.onboarding(),
    queryFn: () => apiFetch<OnboardingTaskRow[]>("/portal/onboarding"),
  });
}
